import WithRender from "../../templates/layouts/layoutStockDefaultPdfConfiguration.html";

export default WithRender({});
